import {LangKeyType} from '../../provider/locale/translation/type';

enum ReviewConditionHistoryKeyEnum {
    DeletedFalseTrue = 'deleted:False-True',
    DeletedTrueFalse = 'deleted:True-False',
    ModeratedFalseTrue = 'moderated:False-True',
    ModeratedTrueFalse = 'moderated:True-False',
}

const reviewConditionHistoryLocaleKeyMap: Record<ReviewConditionHistoryKeyEnum, LangKeyType> = {
    [ReviewConditionHistoryKeyEnum.DeletedFalseTrue]: 'REVIEWS__REVIEW_HISTORY__DELETED_ON_CATALOG',
    [ReviewConditionHistoryKeyEnum.DeletedTrueFalse]: 'REVIEWS__REVIEW_HISTORY__RESTORED_ON_CATALOG',
    [ReviewConditionHistoryKeyEnum.ModeratedFalseTrue]: 'REVIEWS__REVIEW_HISTORY__MOVED_TO_CONFIRMED_ON_CATALOG',
    [ReviewConditionHistoryKeyEnum.ModeratedTrueFalse]: 'REVIEWS__REVIEW_HISTORY__MOVED_TO_UNCONFIRMED_ON_CATALOG',
};

export function getReviewConditionHistoryLocaleKey(
    field: string,
    oldValue: unknown,
    newValue: unknown
): LangKeyType | null {
    const historyKey = `${field}:${oldValue}-${newValue}`;

    switch (historyKey) {
        case ReviewConditionHistoryKeyEnum.DeletedFalseTrue:
        case ReviewConditionHistoryKeyEnum.DeletedTrueFalse:
        case ReviewConditionHistoryKeyEnum.ModeratedFalseTrue:
        case ReviewConditionHistoryKeyEnum.ModeratedTrueFalse:
            return reviewConditionHistoryLocaleKeyMap[historyKey];
        default:
            return null;
    }
}
